<template lang='pug'>
div.relative
  .float-right.d-flex.align-items-center
    a.btn.btn-sm.btn-default(v-on:click="fetch()" v-if='env == "test"'): fa(icon="refresh")
    |
    a.btn.btn-sm(v-on:click="toggleBm()" title="Vergleichen Sie Ihre Daten mit der Community" :class='{"btn-primary active": benchmarkMode, "btn-outline-primary": !benchmarkMode }' v-if='!hideBmButton')
      fa(icon="clone")
    a.btn.btn-sm(@click='toggleExtrapolate' :title="'Extrapolieren Sie die Daten auf die Gesamtzahl der Bewerber (Rücklaufquote: ' + returnRate + '%)'" :class='{"btn-primary active": extrapolate, "btn-outline-primary": !extrapolate }' v-if='extrapolateEnabled && returnRate')
      fa(icon="chart-line")
    slot(name='extra-buttons')
  br
  br
  pre(v-if='toggle'): code(v-html='response')
  loader(v-if='loading')
  highcharts(v-if='!loading && !error' :options="localChartOptions" v-bind:style="{ minHeight: (height||400)+'px' }" ref='chartEl')

  div.alert.alert-danger(v-if='!loading && error')
    |Fehler beim Abrufen, bitte probieren Sie es später noch einmal
  div.text-center(style='position: absolute; bottom: 5px; right: 0; left: 0; margin: 5px;' v-if='showUnselectAll')
    button.btn.btn.btn-outline-dark.btn-sm(@click.prevent='unselectAll')
      |Alle abwählen

</template>

<script>
import AutoRefresh from 'next_report/utils/AutoRefresh'
import Api from '../api.js';
import Loader from './Loader.vue';
import { mapState } from 'vuex'

export default {
  components: {
    Loader,
  },
  mixins: [AutoRefresh],
  props: ['type', 'params', 'options', 'benchmarkOptions', 'benchmarkOpen', 'benchmarkEnabled', 'height', 'public', 'extrapolateEnabled', 'extrapolateActive'],
  data() {
    return {
      loading: true,
      error: false,
      response: null,
      toggle: false,
      extrapolate: !!this.extrapolateActive,
      benchmarkMode: true,
      hideBmButton: false
    }
  },
  computed: {
    returnRate() {
      return this.$store.getters.returnRate
    },
    showUnselectAll() {
      return this.localChartOptions && this.localChartOptions.legend && this.localChartOptions.legend.enabled && this.localChartOptions.series && this.localChartOptions.series.length > 5
    },
    ...mapState(['filter']),
    localChartOptions() {
      if (this.response == null) return {}
      if (this.benchmarkMode) {
        return this.benchmarkOptions(this.response)
      } else {
        return this.options(this.response, this.extrapolate)
      }
    },
    env() { return this.$store.state.env }
  },
  watch: {
    params() {
      this.fetch()
    },
    type() {
      this.fetch()
    },
    filter: {
      deep: true,
      handler() { this.fetch() },
    }
  },
  created() {
    if (this.benchmarkEnabled == false) {
      this.benchmarkMode = false
      this.hideBmButton = true
    }
    if (this.benchmarkOpen !== undefined) {
      this.benchmarkMode = this.benchmarkOpen == "true" || this.benchmarkOpen == true
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    unselectAll() {
      const chartEl = this.$refs.chartEl
      if (!chartEl) { return }
      chartEl.chart.series.forEach(s => s.hide())
    },
    toggleBm() {
      this.benchmarkMode = !this.benchmarkMode
    },
    toggleExtrapolate() {
      this.benchmarkMode = false
      this.extrapolate = !this.extrapolate
    },
    fetch() {
      this.loading = true
      this.error = false
      this.response = null
      if (this.public) {
        Api.get("public_chart/query_form", { type: this.type }).then(
          (response) => {
            this.response = response.data
            this.loading = false
          },
          (response) => {
            this.error = true
            this.loading = false
          }
        )
      } else {
        Api.fetch(this.type, this.params).then(
          (response) => {
            this.response = response.data
            this.loading = false
            this.$emit('update', this.response)
          },
          (response) => {
            this.error = true
            this.loading = false
          }
        )
      }
    }
  }
}
</script>

<style scoped>
  pre {
    position: absolute;
    width: 90%;
    z-index: 2;
    margin-top: 25px;
  }
  a.btn.active {
    border-bottom-width: 0px;
    border-left-width: 2px;
    border-right-width: 0px;
    transition: all 0.1s ease-in-out;
  }
</style>
